import { useNavigate } from "react-router-dom";
import "./Dashboard.scss";
import Header from "../header/Header";
import SubHeader from "../subheader/Subheader";
import Footer from "../footer/Footer";
import { useContext, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "react-bootstrap";
import Statistics from "./Statistics";
import EmployeeEngagementSurveyBarChart from "./EmployeeEngagementSurveyBarChart";
import { UserContext } from "../../routes/routes";
import FormInfoBarChart from "./FormInfoBarChart";
import Driver from "driver.js";
import "driver.js/dist/driver.css";

export default function Dashboard() {
  const [selectedSurvey, setSelectedSurvey] = useState<any>();
  const [isSurveySelected, setIsSurveySelected] = useState(false);

  const navigate = useNavigate();
  const { appContextdata } = useContext<any>(UserContext);

  useEffect(() => {
    if (appContextdata?.IsSystemGeneratedPassword === "true") {
      navigate("/changePassword");
    }
  }, [appContextdata?.IsSystemGeneratedPassword]);

  
  return (
    <div className="dashboard">
      <Header />
      <SubHeader />
      <Container fluid>
        <Card>
          <CardHeader>
            {/* <h2 className="page-title">Dashboard</h2> */}
          </CardHeader>
          <CardBody>
            <Row>
              {/* <Col md={12}></Col>   */}
              <Statistics />
            </Row>
            <Row>
              <Col lg="6" md="12">
                <EmployeeEngagementSurveyBarChart
                  selectedSurvey={selectedSurvey}
                  setSelectedSurvey={setSelectedSurvey}
                  isSurveySelected={isSurveySelected}
                  setIsSurveySelected={setIsSurveySelected}
                />
              </Col>
              <Col lg="6" md="12">
                <FormInfoBarChart
                  isSurveySelected={isSurveySelected}
                  selectedSurvey={selectedSurvey}
                  setSelectedSurvey={setSelectedSurvey}
                />
              </Col>
            </Row>
            <Row></Row>
            <Row className="mt-3">
              {/* <Col md={2}><button onClick={() => navigate(assessmentTypes)} className='submit-btn'>Assessment Type</button></Col>
              <Col md={2}><button onClick={() => navigate(questionCategory)} className='submit-btn'>Question Category</button></Col>
              <Col md={2}><button onClick={() => navigate(responseTypes)} className='submit-btn'>Response Type</button></Col>
              <Col md={2}><button onClick={() => navigate(organizations)} className='submit-btn'>Organization </button></Col> */}
            </Row>
          </CardBody>
        </Card>
      </Container>
      <Footer />
    </div>
  );
}
